module.exports = __webpack_public_path__ + "static/15 - BA-45c10e8ac1a6aaa032e25778016b2d3c.png";